import { api, LightningElement } from "lwc";
import { ChildSummary } from "../childSummary/types";
import { hoursMinutesLabel, pointLabel } from "common/labels";

export default class extends LightningElement {
  @api summary: ChildSummary = null!;
  @api titleMode: "anchor" | "button" | "text" = "anchor";

  private onNavigate() {
    this.dispatchEvent(new CustomEvent("navigate", { detail: this.summary }));
  }

  private get user() {
    return this.summary.user || { finishedAt: null, pointsEarned: null };
  }

  private get subtitle() {
    if (this.user.finishedAt) {
      return pointLabel(this.user.pointsEarned);
    }

    if (this.summary.estimatedTime) {
      return hoursMinutesLabel(this.summary.estimatedTime);
    }

    return undefined;
  }

  private get complete() {
    return this.user.finishedAt ? true : false;
  }
}
